import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'lsq-button-spinner',
    template: `
        <div class="loader text-center">
            <div class="spinner-wrapper" [ngClass]="{ 'black-spinner': isBlackSpinner }">
                <div class="spinner-background">
                    <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="25px"
                        height="25px"
                        viewBox="0 0 25 25"
                        style="enable-background:new 0 0 50 50;"
                        xml:space="preserve"
                    >
                        <circle cx="50%" cy="50%" r="25"></circle>
                    </svg>
                </div>
                <mat-progress-spinner
                    diameter="25"
                    strokeWidth="4"
                    mode="indeterminate"
                ></mat-progress-spinner>
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-button-spinner.component.scss']
})
export class LsqButtonSpinnerComponent {
    @Input() public isBlackSpinner?: boolean;
}
